import React from "react"
// import { Link } from "gatsby"

import Layout from "../components/layout"
// import Image from "../components/image"
import SEO from "../components/seo"
import { withPrefix } from 'gatsby'

const Ranking2018Page = () => (
  <Layout>
    <SEO
      title="Ranking2018 | 日本商工会議所「日商簿記-1グランプリ2024」公式サイト"
      description="「日商簿記-1グランプリ2024」2018年ランキングページです。"
    />
    <div className="title"><h1><img src={withPrefix('/images/icon_under_0011.png')} alt="2018年ランキング｜日本商工会議所「日商簿記-1グランプリ2024」公式サイト" /> 2018</h1></div>
    <div className="description" id="js-height">
      <div className="rankboxwrap">
        <div className="rankbox">
          <div className="ranknum"><img src={withPrefix('/images/ranknum_0001.png')} alt="1st" /></div>
          <div className="score">276点</div>
          <div className="name"><p>大原簿記医療観光専門学校津校</p><h3>大原簿記医療観光専門学校津校</h3></div>
        </div>
      </div>
      <div className="rankboxwrap">
        <div className="rankbox">
          <div className="ranknum"><img src={withPrefix('/images/ranknum_0002.png')} alt="2nd" /></div>
          <div className="score">273点</div>
          <div className="name"><p>熊本県立熊本商業高等学校</p><h3>熊本商業高校簿記部Ａ</h3></div>
        </div>
      </div>
      <div className="rankboxwrap">
        <div className="rankbox">
          <div className="ranknum"><img src={withPrefix('/images/ranknum_0003.png')} alt="3rd" /></div>
          <div className="score">257点</div>
          <div className="name"><p>大原学園 難波校</p><h3>OK-Mint</h3></div>
        </div>
      </div>
      <div className="rankboxwrap">
        <div className="rankbox">
          <div className="ranknum"><img src={withPrefix('/images/ranknum_0004.png')} alt="4th" /></div>
          <div className="score">256点</div>
          <div className="name"><p>大原学園町田校</p><h3>DREAMチームA</h3></div>
        </div>
      </div>
      <div className="rankboxwrap">
        <div className="rankbox">
          <div className="ranknum"><img src={withPrefix('/images/ranknum_0005.png')} alt="5th" /></div>
          <div className="score">248点</div>
          <div className="name"><p>大原簿記情報ビジネス医療福祉専門学校盛岡校</p><h3>大原学園 盛岡校 A</h3></div>
        </div>
      </div>
      <div className="rankboxwrap">
        <div className="rankbox">
          <div className="ranknum"><img src={withPrefix('/images/ranknum_0006.png')} alt="6th" /></div>
          <div className="score">247点</div>
          <div className="name"><p>東京ＣＰＡ会計学院</p><h3>ルカ・パチョーリ６世</h3></div>
        </div>
      </div>
      <div className="rankboxwrap">
        <div className="rankbox">
          <div className="ranknum"><img src={withPrefix('/images/ranknum_0007.png')} alt="7th" /></div>
          <div className="score">243点</div>
          <div className="name"><p>仙台大原簿記情報公務員専門学校</p><h3>仙台大原Ａ</h3></div>
        </div>
      </div>
      <div className="rankboxwrap">
        <div className="rankbox">
          <div className="ranknum"><img src={withPrefix('/images/ranknum_0008.png')} alt="8th" /></div>
          <div className="score">243点</div>
          <div className="name"><p>大原学園 東京校</p><h3>東京スカイロケッツＡ</h3></div>
        </div>
      </div>
      <div className="rankboxwrap">
        <div className="rankbox">
          <div className="ranknum"><img src={withPrefix('/images/ranknum_0009.png')} alt="9th" /></div>
          <div className="score">238点</div>
          <div className="name"><p>大原学園 立川校</p><h3>KOBAHAMA/A</h3></div>
        </div>
      </div>
      <div className="rankboxwrap">
        <div className="rankbox">
          <div className="ranknum"><img src={withPrefix('/images/ranknum_0010.png')} alt="10th" /></div>
          <div className="score">237点</div>
          <div className="name"><p>朝日大学</p><h3>ANY</h3></div>
        </div>
      </div>
      <div className="rankboxwrap">
        <div className="rankbox">
          <div className="ranknum"><img src={withPrefix('/images/ranknum_0010.png')} alt="10th" /></div>
          <div className="score">237点</div>
          <div className="name"><p>大原学園 長野校</p><h3>ＪａＳＲＡ長野</h3></div>
        </div>
      </div>
      <div className="rankboxwrap">
        <div className="rankbox">
          <div className="ranknum"><img src={withPrefix('/images/ranknum_0012.png')} alt="12th" /></div>
          <div className="score">235点</div>
          <div className="name"><p>大原学園 福岡校</p><h3>大原学園 福岡校Aチーム</h3></div>
        </div>
      </div>
      <div className="rankboxwrap">
        <div className="rankbox">
          <div className="ranknum"><img src={withPrefix('/images/ranknum_0013.png')} alt="13th" /></div>
          <div className="score">233点</div>
          <div className="name"><p>城南静岡高等学校</p><h3>城南静岡B</h3></div>
        </div>
      </div>
      <div className="rankboxwrap">
        <div className="rankbox">
          <div className="ranknum"><img src={withPrefix('/images/ranknum_0014.png')} alt="14th" /></div>
          <div className="score">231点</div>
          <div className="name"><p>大原簿記法律専門学校 京都校</p><h3>京喜乱舞 A</h3></div>
        </div>
      </div>
      <div className="rankboxwrap">
        <div className="rankbox">
          <div className="ranknum"><img src={withPrefix('/images/ranknum_0015.png')} alt="15th" /></div>
          <div className="score">229点</div>
          <div className="name"><p>大原学園千葉校</p><h3>千葉校Bチーム</h3></div>
        </div>
      </div>
      <div className="rankboxwrap">
        <div className="rankbox">
          <div className="ranknum"><img src={withPrefix('/images/ranknum_0016.png')} alt="16th" /></div>
          <div className="score">228点</div>
          <div className="name"><p>熊本県立熊本商業高等学校</p><h3>熊本商業高校簿記部Ｂ</h3></div>
        </div>
      </div>
      <div className="rankboxwrap">
        <div className="rankbox">
          <div className="ranknum"><img src={withPrefix('/images/ranknum_0017.png')} alt="17th" /></div>
          <div className="score">227点</div>
          <div className="name"><p>仙台大原簿記情報公務員専門学校</p><h3>仙台大原Ｂ</h3></div>
        </div>
      </div>
      <div className="rankboxwrap">
        <div className="rankbox">
          <div className="ranknum"><img src={withPrefix('/images/ranknum_0018.png')} alt="18th" /></div>
          <div className="score">222点</div>
          <div className="name"><p>大原簿記法律専門学校難波校</p><h3>NMB12 team A</h3></div>
        </div>
      </div>
      <div className="rankboxwrap">
        <div className="rankbox">
          <div className="ranknum"><img src={withPrefix('/images/ranknum_0019.png')} alt="19th"  /></div>
          <div className="score">220点</div>
          <div className="name"><p>岐阜県立岐阜商業高校</p><h3>シシャモ</h3></div>
        </div>
      </div>
      <div className="rankboxwrap">
        <div className="rankbox">
          <div className="ranknum"><img src={withPrefix('/images/ranknum_0020.png')} alt="20th"  /></div>
          <div className="score">219点</div>
          <div className="name"><p>大原学園 福岡校</p><h3>大原学園 福岡校Bチーム</h3></div>
        </div>
      </div>
    </div>
    <div className="wrapBtmLink">
      <a href="https://www.kentei.ne.jp/boki_1_2018_u21" target="_blank" rel="noopener noreferrer">&raquo; 21位以下はこちら</a>
    </div>

    <div className="pastRank">
      <h2>過去のランキング</h2>
      <ul>
        <li><a href="/boki-1/ranking2017">&raquo; Ranking 2017</a></li>
        <li><a href="/boki-1/ranking2016">&raquo; Ranking 2016</a></li>
      </ul>
    </div>
  </Layout>
)

export default Ranking2018Page
